module.exports = __webpack_public_path__ + "static/media/arrow-alt-right.840dc43d.svg";